module.exports = __webpack_public_path__ + "img/logomax.592fb1ea.png";